<template>
  <div class="d-flex flex-row justify-content-between flex-wrap pb-1">
    <h2 class="text-bg">{{ title }}</h2>
    <router-link to="create" style="text-decoration: none">
      <n-button type="info" size="medium" style="font-size: 20px">
        <i class="icon-plus" style="padding-right: 12px"></i>
        {{ buttonText }}
      </n-button>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    buttonText: String,
    routeName: String,
  },
  methods: {
    redirectToCreateSupply() {
      this.$router.push({ name: this.routeName });
    },
  },
};
</script>
